<template>
    <span v-if="type === 'device-health-icon'">
        <device-health-icon
            v-model="reactiveValue"
            v-bind="props"
            v-on="on"
        ></device-health-icon>
    </span>
    <span v-else-if="type === 'pms-status'">
        <pms-status
            v-model="reactiveValue"
            v-bind="props"
            v-on="on"
        ></pms-status>
    </span>
    <component
        :is="type"
        v-else-if="mask"
        v-model="reactiveValue"
        v-mask="mask"
        v-bind="props"
        v-on="on"
    ></component>
    <component
        :is="type"
        v-else
        v-model="reactiveValue"
        v-bind="props"
        v-on="on"
    ></component>
</template>

<script>
import DeviceHealthIcon from '@/components/Fields/DeviceHealthIcon';
import TagsChipGroup from '@/components/Fields/TagsChipGroup';
import VLabelField from '@/components/Fields/VLabelField';
import DateSelect from '@/components/Fields/DateSelect';
import ActionLinkButton from '@/components/Fields/ActionLinkButton';
import PrefixSelect from '@/components/Fields/PrefixSelect';
import PmsStatus from '@/components/Fields/PmsStatus';
import {
    VBtn,
    VCheckbox,
    VTextField,
    VSelect,
    VAutocomplete,
    VSwitch,
    VTooltip
} from 'vuetify/lib';
import { mask, tokens } from 'vue-the-mask';

export default {
    name: 'GenericField',
    directives: {
        mask
    },
    components: {
        'v-btn': VBtn,
        'v-checkbox': VCheckbox,
        'v-text-field': VTextField,
        'v-select': VSelect,
        'v-autocomplete': VAutocomplete,
        'v-switch': VSwitch,
        'v-tooltip': VTooltip,
        'v-label-field': VLabelField,
        'device-health-icon': DeviceHealthIcon,
        'tags-chip-group': TagsChipGroup,
        'date-select': DateSelect,
        'action-link-button': ActionLinkButton,
        'prefix-select': PrefixSelect,
        'pms-status': PmsStatus
    },
    props: {
        type: {
            type: String,
            required: false,
            default: 'v-label-field'
        },
        props: {
            type: Object,
            default: () => {}
        },
        on: {
            type: Object,
            default: () => {}
        },
        value: {
            type: null,
            required: true
        }
    },
    computed: {
        reactiveValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        extendendTokens() {
            // need to extend the v-the-mask tokens and add custom tokens
            return {
                ...tokens,
                F: {
                    pattern: /[0-9a-fA-F]/,
                    transform: v => v.toLocaleUpperCase()
                },
                '*': { pattern: /./ }
            };
        },
        mask() {
            if (this.props && this.props.mask) {
                return {
                    mask: this.props.mask,
                    tokens: this.extendendTokens
                };
            }
            return '';
        }
    }
};
</script>

<style></style>
